import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import * as moment from 'moment';
import ConstantDetail from './ConstantDetail';

export default class ListConstants extends Component {
  static propTypes = {
    constants: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  showConstantValue = (constantType, value) => {
    if (constantType === 'DATE') {
      return moment(value).format('dddd, MMMM Do YYYY, h:mm:ss a');
    }
    if (constantType === 'BOOLEAN') {
      return value ? 'true' : 'false';
    }
    return value;
  };

  showConstantsDetail = (constant) => {
    const {
      projectId,
      collection,
      actions,
      commonActions,
      version,
      showDerivedConstantLoader,
      showConstantDeleteLoader,
      deleteFlag,
      isReadOnly,
    } = this.props;
    return (
      <AccordionItem key={constant.name}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb`}></i> <strong>{constant.name}</strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <ConstantDetail
            projectId={projectId}
            version={version}
            collection={collection}
            actions={actions}
            commonActions={commonActions}
            showConstantValue={this.showConstantValue}
            constant={constant}
            showDerivedConstantLoader={showDerivedConstantLoader}
            showConstantDeleteLoader={showConstantDeleteLoader}
            deleteFlag={deleteFlag}
            isReadOnly={isReadOnly}
          />
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { constants } = this.props;
    if (constants && constants.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-12">
            <Accordion allowZeroExpanded>
              {' '}
              {constants.map((constant) => this.showConstantsDetail(constant))}
            </Accordion>
          </div>
        </div>
      );
    }
    return (
      <div>
        <h5 className="text-center">No Constants!</h5>
      </div>
    );
  }
}
